export default "__VITE_ASSET__8H1OziwN__"